import { render, staticRenderFns } from "./vHome.vue?vue&type=template&id=1aa9f9c6&scoped=true"
import script from "./vHome.vue?vue&type=script&lang=js"
export * from "./vHome.vue?vue&type=script&lang=js"
import style0 from "./vHome.vue?vue&type=style&index=0&id=1aa9f9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa9f9c6",
  null
  
)

export default component.exports